import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  return <header className="bg-gradient-to-r from-primary-800 to-primary-700 text-white shadow-md relative z-20" data-id="element-248">
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-249"></div>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center relative z-10" data-id="element-250">
        <div className="flex items-center space-x-2" data-id="element-251">
          <span className="font-display font-semibold text-xl" data-id="element-252">
            Early Warning Report
          </span>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-253">
          <Link to="/" className="font-medium hover:text-primary-200 transition-colors" data-id="element-254">
            Home
          </Link>
          <Link to="/timeline" className="font-medium hover:text-primary-200 transition-colors" data-id="element-255">
            Timeline
          </Link>
          <Link to="/faqs" className="font-medium hover:text-primary-200 transition-colors" data-id="element-256">
            FAQs
          </Link>
          <Link to="/about" className="font-medium hover:text-primary-200 transition-colors" data-id="element-257">
            About
          </Link>
          <Link to="/contact" className="font-medium hover:text-primary-200 transition-colors" data-id="element-258">
            Contact
          </Link>
        </nav>
        <button className="md:hidden focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-259">
          {isMenuOpen ? <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-260">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-261" />
            </svg> : <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-262">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-263" />
            </svg>}
        </button>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-264">
          <div className="fixed inset-0 bg-black bg-opacity-50 z-30" onClick={closeMenu} aria-hidden="true" data-id="element-265"></div>
          <nav className="relative bg-primary-700 py-4 px-4 shadow-lg z-40" data-id="element-266">
            <div className="flex flex-col space-y-3" data-id="element-267">
              <Link to="/" className={`font-medium py-2 px-4 rounded-md ${location.pathname === '/' ? 'bg-primary-600 text-white' : 'hover:bg-primary-600 hover:text-white'}`} onClick={closeMenu} data-id="element-268">
                Home
              </Link>
              <Link to="/timeline" className={`font-medium py-2 px-4 rounded-md ${location.pathname === '/timeline' ? 'bg-primary-600 text-white' : 'hover:bg-primary-600 hover:text-white'}`} onClick={closeMenu} data-id="element-269">
                Timeline
              </Link>
              <Link to="/faqs" className={`font-medium py-2 px-4 rounded-md ${location.pathname === '/faqs' ? 'bg-primary-600 text-white' : 'hover:bg-primary-600 hover:text-white'}`} onClick={closeMenu} data-id="element-270">
                FAQs
              </Link>
              <Link to="/about" className={`font-medium py-2 px-4 rounded-md ${location.pathname === '/about' ? 'bg-primary-600 text-white' : 'hover:bg-primary-600 hover:text-white'}`} onClick={closeMenu} data-id="element-271">
                About
              </Link>
              <Link to="/contact" className={`font-medium py-2 px-4 rounded-md ${location.pathname === '/contact' ? 'bg-primary-600 text-white' : 'hover:bg-primary-600 hover:text-white'}`} onClick={closeMenu} data-id="element-272">
                Contact
              </Link>
            </div>
          </nav>
        </div>}
    </header>;
}